import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { __getTypeProducts } from "request/Pases/__CrudPass";

/**
 * Hook para obtener tipos de productos (getTypeProductsNotPaginate)
 * Cachea los datos para evitar peticiones duplicadas
 * 
 * @param {boolean} enabled - Si la query debe ejecutarse (default: true)
 * @returns {Object} Objeto con data, isLoading, error, etc. de React Query
 */
export const useTypeProducts = (enabled = true) => {
  const token = useSelector((state) => state.auth.dataUser.token);

  return useQuery({
    queryKey: ["typeProducts", "notPaginate"],
    queryFn: async () => {
      const res = await __getTypeProducts(token);
      return res?.data?.status?.data || [];
    },
    enabled: enabled && !!token,
    staleTime: 1000 * 60 * 10, // 10 minutos - los datos de configuración cambian poco
    gcTime: 1000 * 60 * 30, // 30 minutos en caché
    refetchOnMount: false, // No refetch al montar si los datos están frescos
    refetchOnWindowFocus: false, // No refetch al cambiar de ventana
    retry: 1, // Solo reintentar una vez en caso de error
  });
};
